export const nl = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Terug",
        save: "Opslaan",
        saved: "Opgeslagen",
        cancel: "Annuleren",
        close: "Sluiten",
        accessDenied: "Toegang Geweigerd",
        noExportPermission: "U heeft geen toestemming om deze autogegevens te exporteren.",
        delete: "Verwijderen",
        downgrade: "Downgrade",
        downgradeConfirm: "Weet u zeker dat u wilt downgraden naar het Gratis plan?",
        edit: "Bewerken",
        loading: "Laden...",
        confirm: "Bevestigen",
        processing: "Verwerken...",
        history: "Geschiedenis",
        currentCar: "Huidige Auto",
        purchasedCarTitle: "Aankoop Auto",
        initialCost: "Aanvangskosten",
        done: "Klaar",
        ok: "OK",
        error: "Fout",
        errorSaving: "Fout bij het opslaan van gegevens",
        mandatoryFieldsError: "Vul alstublieft alle verplichte velden correct in.",
        search: "Zoeken",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Ongeldig e-mailformaat",
        today: "Vandaag",
        car: "Auto",
        all: "Alle",
        deleteConfirm: "Verwijderen",
        unsavedChangesTitle: "Niet-opgeslagen Wijzigingen",
        unsavedChangesMessage: "Wilt u wijzigingen opslaan voordat u vertrekt?",
        dontSave: "Niet Opslaan",
        additionalOptions: "Aanvullende opties",
        add: "Toevoegen",
        fileTooLarge: "Bestand is te groot. Maximale grootte is {limit} MB.",
        storageFull: "Opslaglimiet overschreden. Maximale opslag is {limit} MB.",
        dailyUploadLimit: "Dagelijkse uploadlimiet bereikt ({limit} bestanden/dag). Probeer het morgen opnieuw.",
        hourlyUploadLimit: "Uurlikse uploadlimiet bereikt ({limit} bestanden/uur). Probeer het over een uur opnieuw.",
        fileCountLimit: "Maximaal {limit} bestanden toegestaan per item.",
        emailParseLimitReached: "E-mail parsing limiet bereikt. Upgrade uw plan of verwerk handmatig.",
        emailLimitText: "E-mailverwerkingslimiet bereikt.",
        monthlyEmailScans: "Maandelijkse E-mail Scans",
        lifetimeEmailScans: "Levenslange E-mail Scans",
        monthlyFileScans: "Maandelijkse Ontvangst Scans",
        lifetimeFileScans: "Levenslange Ontvangst Scans",
        fileLimitText: "Limiet voor ontvangstscans bereikt.",
        planFreeTier: "Gratis niveau",
        planProTier: "Pro niveau",
        uploadFailed: "Upload mislukt",
        attachments: "Bijlagen",
        limitsAndUsage: "Limieten & Gebruik",
        addresses: "adressen",
        emailCopied: "E-mailadres gekopieerd!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Inbegrepen",
        proOnly: "Alleen PRO",
        month: "mnd",
        openInNewTab: "Open in nieuw tabblad",
        menu: "Menu",
        home: "Start",
        monthsShort: {
            0: "Jan",
            1: "Feb",
            2: "Mrt",
            3: "Apr",
            4: "Mei",
            5: "Jun",
            6: "Jul",
            7: "Aug",
            8: "Sep",
            9: "Okt",
            10: "Nov",
            11: "Dec",
        },
    },
    carMetadata: {
        bodyType: "Carrosserievorm",
        drivetrain: "Aandrijflijn",
        transmission: "Transmissie",
        bodyTypes: {
            sedan: "Sedan",
            hatchback: "Hatchback",
            wagon: "Stationwagen",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupé",
            convertible: "Cabriolet",
            pickup: "Pickup",
            van: "Bus / Minibus",
            commercial: "Commercieel",
            other: "Overig",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Overig",
        },
        transmissions: {
            not_specified: "-",
            manual: "Handmatig",
            automatic: "Automatisch",
            cvt: "CVT",
            other: "Overig",
        },
        otherLabel: "Overig (specificeer)",
        mileageLabel: "Kilometerstand",
    },
    auth: {
        welcome: "Welkom",
        welcomeBack: "Welkom Terug",
        signIn: "Inloggen",
        signInWithGoogle: "Inloggen met Google",
        signOut: "Uitloggen",
        magicLinkDesc: "Ontvang een magische link in uw e-mail",
        magicLinkSent: "Magische link verzonden!",
        magicLinkCheckEmail: "Controleer uw e-mail en klik op de link om in te loggen.",
        emailAddress: "E-mailadres",
        getMagicLink: "Ontvang Magische Link",
        sending: "Verzenden...",
        linkSent: "Link Verzonden",
        orContinueWith: "Of ga verder met",
        googleAccount: "Google-account",
        newUserNote: "Nieuw hier? Uw account wordt automatisch aangemaakt bij uw eerste succesvolle inlog.",
        magicLinkError: "Verzenden van de magische link mislukt. Controleer uw e-mail en probeer het opnieuw.",
        genericError: "Er is een fout opgetreden. Probeer het opnieuw.",
        projectDescription: "Houd uw autokosten, onderhoud en geschiedenis op één plek bij.",
        loginError: "Inloggen niet mogelijk",
        loggingIn: "Inloggen...",
        authenticating: "Authenticeren...",
        authenticatingDesc: "Even geduld terwijl we uw sessie beveiligen.",
    },
    settings: {
        title: "Instellingen",
        systemPreferences: "Systeemvoorkeuren",
        appSettings: "App-instellingen",
        dangerZone: "Gevarenzone",
        theme: "Thema",
        language: "Interface Taal",
        currency: "Valuta",
        units: "Eenheden",
        distanceUnit: "Afstandseenheid",
        volumeUnit: "Volume-eenheid",
        expenseTypes: "Uitgavencategorieën",
        expenseTypesDesc: "Beheer categorieën",
        categories: "Categorieën",
        exportData: "Gegevens Exporteren",
        exportDesc: "Download uitgebreide CSV",
        importData: "Gegevens Importeren",
        importDesc: "Herstellen vanuit CSV-back-up",
        deleteAccount: "Account Verwijderen",
        deleteAccountDesc: "Verwijder alle gegevens permanent",
        enableSync: "Synchronisatie Inschakelen",
        enableSyncDesc: "Synchroniseer gegevens tussen apparaten",
        account: "Account",
        accountPlan: "Accountplan",
        carsUsage: "Auto's",
        carsLimitReached: "Auto limiet bereikt",
        storageSize: "Opslaggrootte",
        emailScans: "E-mail Scans",
        fileScans: "Ontvangst Scans",
        plans: "Plannen",
        currentlyPlan: "Huidig",
        upgradePlan: "Upgrade",
        manageSubscription: "Abonnement beheren",
        nextPayment: "Volgende betaling",
        endsOn: "Eindigt op",
        adminConsole: "Beheerdersconsole",
        systemControl: "Systeembeheer",
        customCategories: "Aangepaste Categorieën & Labels",
        interfaceTheme: "Interface Thema",
        light: "Licht",
        dark: "Donker",
        timezone: "Tijdzone",
        timezoneDesc: "Gebruikt voor geplande e-mailherinneringen",
        timeFormat: "Tijdformaat",
        timeFormat24h: "24-uurs (14:30)",
        timeFormat12h: "12-uurs (2:30 PM)",
        kilometers: "kilometers (km)",
        miles: "mijlen (mi)",
        liters: "liters (l)",
        gallons: "gallons (gal)",
        accountManagement: "Accountbeheer",
        contactUs: "Neem contact met ons op",
        contactDesc: "Voor suggesties, functieaanvragen en vragen",
        logOut: "Uitloggen",
        logOutConfirmTitle: "Uitloggen",
        logOutConfirmMessage: "Weet je zeker dat je uit je account wilt uitloggen?",
        keepAccount: "Account Behouden",
        deleteAccountConfirmTitle: "Account Verwijderen",
        deleteAccountConfirmMessage: "Weet je zeker dat je je account en alle bijbehorende autogegevens permanent wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        deletePermanently: "Permanent Verwijderen",
        deleting: "Verwijderen...",
        contactSupport: "Neem Contact Op met Ondersteuning",
        messageSent: "Bericht Verzonden!",
        feedbackThanks: "Bedankt voor je feedback. We waarderen je input en zullen het bekijken.",
        backToSettings: "Terug naar Instellingen",
        subjectLabel: "Onderwerp",
        messageLabel: "Bericht",
        subjectPlaceholder: "Waar gaat dit over?",
        messagePlaceholder: "Vertel ons over je suggestie, functieaanvraag of vraag...",
        enterSubjectAlert: "Voer alstublieft een onderwerp in",
        enterMessageAlert: "Voer alstublieft een bericht in",
        sendFailedAlert: "Verzenden van het bericht is mislukt. Probeer het later opnieuw.",
    },
    export: {
        title: "Gegevens Exporteren",
        generatePDF: "PDF Genereren",
        carInformation: "Auto-informatie",
        editInfo: "Bewerk de onderstaande informatie om je export aan te passen",
        editInfoHint: "Je kunt velden verwijderen of wijzigen die je niet wilt opnemen",
        filters: "Filters",
        expenseTypes: "Uitgavencategorieën",
        includeNotes: "Notities Insluiten",
        includeImages: "Bestanden Insluiten",
        hideDisabled: "Verberg Uitgeschakelde Items",
        itemsCount: "{total} items, {selected} geselecteerd",
        selectAll: "Selecteer Alles",
        deselectAll: "Deselecteer Alles",
        expenses: "Uitgaven",
        notes: "Notities",
        spareParts: "Reserveonderdelen",
        images: "Afbeeldingen",
        files: "Bestanden",
        summary: "Samenvatting",
        totalExpenses: "Totale Uitgaven",
        totalItems: "Totaal Aantal Items",
        generatedOn: "Gegenereerd op",
        noItemsSelected: "Geen items geselecteerd voor export",
        noItemsAvailable: "Geen items beschikbaar om te exporteren",
        generating: "PDF aan het genereren...",
        downloadPDF: "PDF Downloaden",
        pdfFileName: "{carName}_export_{date}.pdf",
        reportTitle: "Uitgavenrapport auto",
        exportButton: "Exporteren",
        generateCSV: "CSV genereren",
        formatSelectorTitle: "Kies formaat",
        formatSelectorMsg: "Kies het exportformaat",
        proFeatureExportTitle: "Pro-functie: Gegevens exporteren",
        proFeatureExportDesc: "Upgrade naar PRO om uw autogeschiedenis naar PDF te exporteren.",
        exportRestrictedPopup: "Gegevensexport is alleen beschikbaar voor Pro-gebruikers.",
        allTypes: "Alle Typen",
        statistics: "Statistieken",
        driven: "Gegereden",
        since: "Sinds",
        averageCost: "Gemiddelde Kosten",
        perKm: "per km",
        perMile: "per mijl",
        period: "Periode",
        dateFrom: "Van",
        dateTo: "Tot",
        allTime: "Filter wissen",
        periodHint: "Als er geen periode is geselecteerd — worden alle uitgaven weergegeven",
        noExpenses: "Geen uitgaven die aan de filters voldoen",
        expensesSection: "Uitgaven",
        attachmentsSection: "Bijlagen",
        imagesCount: "{count} afbeeldingen",
        pdfsCount: "{count} PDF's",
        includeParts: "Inclusief reserveonderdelen",
        pageLabel: "Pagina",
    },
    expenses: {
        title: "Uitgaven",
        newExpense: "Nieuwe Uitgave",
        editExpense: "Bewerk Uitgave",
        openExpense: "Open Uitgave-invoer",
        details: "Uitgave Details",
        selectType: "Selecteer Type",
        selectTypePlaceholder: "Selecteer uitgavetype...",
        shortDescriptionPlaceholder: "Korte beschrijving...",
        expenseTitle: "Titel",
        logEntryTitleLabel: "Record Titel (Optioneel)",
        defaultTitlePlaceholder: "Standaard titel - {type}",
        autoTitlePlaceholder: "Wordt automatisch ingevuld op basis van geselecteerde types",
        carDataTitle: "Autogegevens",
        defaultTitlePrefix: "Standaard titel zal zijn -",
        addAnother: "Voeg een ander type uitgave toe",
        addAnotherHint: "Als dit record meerdere types uitgaven bevat, kunt u ze hier allemaal toevoegen voor nauwkeurige statistieken.",
        carValueDescription: "Geschatte marktwaarde van de auto op dit moment.",
        type: "Type",
        date: "Datum",
        amount: "Bedrag",
        totalAmount: "Totaal",
        splitCosts: "Kosten splitsen?",
        combineCosts: "Kosten combineren",
        amountWork: "Werk",
        amountParts: "Onderdelen",
        mileage: "Kilometerstand",
        carValue: "Waarde van de auto",
        description: "Beschrijving",
        detailedDescription: "Gedetailleerde beschrijving",
        electricity: "Elektriciteit",
        fuelType: "Brandstoftype",
        fuelTypeOptions: {
            petrol: "Benzine",
            diesel: "Diesel",
            lpg: "LPG",
            electricity: "Elektriciteit",
        },
        carData: "Auto Gegevens",
        images: "Bestanden",
        addImages: "Bestanden Toevoegen",
        addImagesPDFs: "Afbeeldingen of PDF's Toevoegen",
        deleteExpense: "Verwijder Uitgave",
        deleteConfirm: "Weet u zeker dat u deze uitgave wilt verwijderen?",
        saveSuccess: "Uitgave succesvol opgeslagen",
        thisExpense: "Deze uitgave",
        stats: {
            annual: "Jaarlijks",
            allTime: "Alle Tijd",
            avgMonth: "Gem. per Maand",
            costPer: "Kosten/",
            noExpenses: "Nog geen uitgaven",
            dragToReorder: "Sleep om te herschikken",
        },
        expensesFound: "Aangemaakt",
        noExpensesFound: "Geen uitgaven gevonden.",
        noDescription: "Geen beschrijving",
        imagesCount: "Afbeeldingen ({count})",
        deleteImageTitle: "Verwijder Afbeelding",
        deleteImageConfirm: "Weet u zeker dat u deze afbeelding wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        typeLabels: {
            fuel: "Brandstof",
            car_wash: "Wassen",
            repairs: "Reparaties",
            maintenance: "Onderhoud",
            parts: "Reserve Onderdelen",
            insurance: "Verzekering",
            inspection: "Inspectie",
            tyres: "Banden",
            parking: "Parkeren",
            electricity: "Elektriciteit",
            taxes: "Belastingen",
            other: "Overig",
            info: "Informatie",
            service_maintenance: "Onderhoud",
            service_repair: "Reparatie",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Service",
            selectSubtype: "Selecteer servicetype",
            maintenance: "Onderhoud",
            repair: "Reparatie",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Herhalende Uitgave",
        repeatToggle: "Herhaal deze uitgave",
        repeatFrequency: "Frequentie",
        monthly: "Maandelijks",
        startDate: "Startdatum",
        nextDate: "Volgende invoer wordt gegenereerd",
        endDate: "Einddatum",
        noEndDate: "Geen einddatum",
        copyOptions: "Kopieeropties",
        copyTitle: "Kopieer recordtitel",
        copyLocation: "Kopieer locatie",
        copyDescription: "Kopieer beschrijving",
        active: "Actief",
        status: "Status",
        managedByRepeat: "Deze uitgave maakt deel uit van een herhalende reeks.",
        placeholder: "Hier kunt u automatische herhaling voor deze uitgave instellen als deze regelmatig met hetzelfde bedrag voorkomt.",
        deleteRepeat: "Verwijder Herhaling",
        deleteRepeatConfirm: "Weet u zeker dat u deze herhalende reeks wilt stoppen en verwijderen? Toekomstige invoeren worden niet gegenereerd. Eerdere invoeren blijven behouden.",
        relatedEntries: "Invoeren in deze reeks",
        stopRepeat: "Stop met herhalen",
        isRepeating: "Herhalend",
        noTerm: "Onbepaalde tijd",
        until: "Laatste invoer wordt gegenereerd",
        summaryCopy: "Systeem zal kopiëren",
        simulate: "Simuleer volgende invoer generatie",
        simulateSuccess: "Volgende invoer generatie succesvol gesimuleerd",
        simulateNoDate: "Geen data meer om te genereren (einddatum bereikt)",
    },
    onboarding: {
        title: "Profiel Instellen",
        welcome: "Welkom!",
        subtitle: "Pas uw rijervaring aan.",
        currency: "Valuta",
        preferredCurrency: "Voorkeursvaluta",
        distUnit: "Afstandseenheid",
        volUnit: "Volume-eenheid",
        complete: "Instelling Voltooien",
    },
    cars: {
        unitChangeWarningTitle: "Waarschuwing voor eenheid wijziging",
        unitChangeWarningMessage: "Het wijzigen van deze eenheden zal uw bestaande gegevens niet converteren. Alle historische records blijven precies zoals ingevoerd.",
        unitChangeWarningConfirm: "Begrijp ik",
        title: "Garage",
        carAdmins: "Auto Beheerders",
        sharedWithMe: "Gedeeld met Mij",
        manageAdmins: "Beheerders Beheren",
        adminEmail: "Beheerder E-mail",
        addAdmin: "Voeg Beheerder Toe",
        addAdminPlaceholder: "bijv. vriend@email.com",
        removeAdmin: "Verwijder",
        removeAdminConfirm: "Weet u zeker dat u deze beheerder wilt verwijderen?",
        adminAdded: "Beheerder toegevoegd",
        adminRemoved: "Beheerder verwijderd",
        removeMyAccess: "Verwijder mijn toegang",
        removeMyAccessConfirm: "Weet u zeker dat u toegang tot deze auto wilt opgeven?",
        myAccessRemoved: "Toegang verwijderd",
        noAdminsYet: "Nog geen beheerders toegevoegd.",
        adminInfoText: "Beheerders kunnen uitgaven, notities en reserveonderdelen toevoegen en bewerken, maar kunnen de auto zelf niet verwijderen.",
        newCar: "Voeg Auto Toe",
        carNotFound: "Auto Niet Gevonden",
        carNotFoundDesc: "De gevraagde auto bestaat niet of je hebt geen toegang.",
        accessDenied: "Toegang Geweigerd",
        accessDeniedDesc: "Deze auto is privé en niet openbaar beschikbaar.",
        backToHome: "Terug naar Start",
        adminRestricted: "Toegang Beperkt",
        adminRestrictedDesc: "Alleen geautoriseerde beheerders kunnen deze console openen. Ga terug naar de hoofdapplicatie.",
        returnHome: "Terug naar Start",
        editCar: "Bewerk Auto",
        name: "Autonaam",
        model: "Model",
        year: "Jaar",
        plate: "Kenteken",
        vin: "VIN-nummer",
        mileage: "Huidige Kilometerstand",
        initialMileage: "Initiële Kilometerstand",
        engineType: "Motor Type",
        tapToChangeIcon: "Tik om het pictogram te wijzigen",
        chooseIcon: "Kies Pictogram",
        imageTab: "Afbeelding",
        iconTab: "Pictogram",
        chooseColor: "Kies Kleur",
        chooseEmoji: "Kies Emoji",
        uploadImage: "Afbeelding Uploaden",
        clickToBrowse: "Klik om bestanden te doorbladeren",
        currentCarIcon: "Huidig auto pictogram",
        changeImage: "Afbeelding Wijzigen",
        zoom: "Inzoomen",
        rotate: "Draaien",
        removeChangeImage: "Verwijder / Wijzig Afbeelding",
        selectIcon: "Selecteer Pictogram",
        cropAndSave: "Bijsnijden & Opslaan",
        displayName: "Weergavenaam",
        displayNamePlaceholder: "bijv. Mijn Weekendauto",
        makeLabel: "Merk *",
        modelLabel: "Model *",
        yearLabel: "Jaar *",
        fuelTypeLabel: "Type *",
        licensePlateLabel: "Kenteken",
        vinLabel: "VIN",
        notesLabel: "Notities",
        notesPlaceholder: "bijv. 1.6 TDI, 85kW, 1588cc, batterij 62kWh, AWD, enz.",
        publicAccess: "Maak auto openbaar toegankelijk",
        publicAccessDesc: "Anderen kunnen deze auto bekijken via een gedeelde link",
        shareLocations: "Sta toe om ook toegevoegde locaties te bekijken",
        shareLocationsDesc: "Schakel dit in om autolocaties zichtbaar te maken in de openbare weergave",
        deleteCar: "Verwijder Auto",
        deleteCarTitle: "Verwijder Auto",
        deleteCarConfirm: "Weet je zeker dat je '{name}' wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        noCars: "Geen auto's in je garage",
        addFirstCarNote: "Begin je reis door je eerste voertuig toe te voegen om uitgaven bij te houden.",
        addVehicle: "Voeg Een Voertuig Toe",
        myVehicles: "Mijn Voertuigen",
        favorites: "Favorieten",
        deleteConfirm: "Weet je zeker dat je deze auto wilt verwijderen? Alle bijbehorende uitgaven worden verwijderd.",
        deleteFailed: "Verwijderen van auto mislukt",
        saveFailed: "Opslaan van autogegevens mislukt",
        adminActions: "Beheerdersacties",
        importCsv: "CSV Importeren",
        clearData: "Gegevens Wissen",
        distanceUnitLabel: "Afstandseenheid",
        volumeUnitLabel: "Volume-eenheid",
        currencyLabel: "Valuta",
        boughtAt: "Aankoopdatum",
        purchasePrice: "Aankoopprijs",
        purchaseMileage: "Aankoopkilometerstand",
        createPurchaseRecord: "Maak automatisch een aankoopgeschiedenisrecord aan",
        makePlaceholder: "bijv. BMW",
        modelPlaceholder: "bijv. X5",
        platePlaceholder: "bijv. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Deze informatie zal een initiële 'Informatie' record in je geschiedenis aanmaken met de opgegeven gegevens.",
        availableTypes: "Beschikbare Types",
        dragToReorder: "Sleep om te herschikken",
        requestTypeNote: "Als je een ander type nodig hebt - ",
        requestTypeAction: "laat het ons weten!",
        emailProcessingTitle: "E-mailverwerking",
        emailInstructions: "Stuur je bonnetjes door naar het onderstaande adres. We extraheren gegevens en creëren automatisch uitgaven.",
        recentEmails: "Ontvangen E-mails",
        viewAllEmails: "BEKIJK ALLE ({count})",
        noEmailsReceived: "Nog geen e-mails ontvangen.",
        analysisResult: "Analyse Resultaat",
        vehicleInfo: "Voertuiginformatie",
        preferences: "Voorkeuren",
        purchaseHistory: "Aankoopgeschiedenis",
        emailProcessing: "E-mailverwerking",
        publicAccessTitle: "Openbare Toegang",
        expenseTypesTitle: "Uitgaventypes",
        adminActionsTitle: "Beheerdersacties",
        enterPurchaseDateAlert: "Voer de aankoopdatum in",
        allowedSenderEmails: "Toegestane Afzender E-mails",
        allowedEmailsDesc: "Voeg e-mailadressen toe die zijn toegestaan om bonnetjes naar deze auto te sturen. Maximaal 5 adressen.",
        noAllowedEmails: "Geen toegestane e-mails toegevoegd.",
        emailAlreadyAdded: "Deze e-mail is al toegestaan voor deze auto.",
        maxAllowedEmailsReached: "Maximale limiet van toegestane e-mails bereikt.",
        addAllowedEmailPlaceholder: "Voeg toegestane e-mail toe...",
        ownerEmail: "Eigenaar",
        onlyOwner: "alleen eigenaar",
        defaultAllowed: "Altijd toegestaan",
        carLimitReachedTitle: "Auto Limiet Bereikt",
        carLimitReachedMessage: "Je {plan} plan staat {limit} auto('s) toe. Je hebt er al {current}. Ga naar instellingen om je limieten te bekijken of neem contact met ons op om te upgraden.",
        carLimitGoToSettings: "Ga naar Instellingen",
        archivedCars: "Gearchiveerd",
        archiveCar: "Auto archiveren",
        unarchiveCar: "Auto dearchiveren",
        sellDate: "Verkoopdatum",
        sellPrice: "Verkoopprijs",
        sellMileage: "Verkoopkilometrage",
        archiveConfirm: "Weet je zeker dat je deze auto wilt archiveren?",
        archiveInstructions: "Het archiveren van een auto betekent dat deze niet langer van jou is of dat je deze niet langer onderhoudt. Geef alstublieft de verkoopgegevens op voor statistieken. Dit maakt de auto alleen-lezen. De onderstaande velden kunnen daarna nog steeds worden bewerkt.",
        archivedBadge: "Gearchiveerd",
        saleDetails: "Verkoopgegevens",
        saleDetailsNote: "Verkoopgegevens worden gebruikt voor statistieken. Je kunt ze indien nodig bijwerken.",
        archiveDetailsNotFillable: "Vul alle velden in om de auto te archiveren",
        emailAddressWillBeAvailableAfterSave: "E-mailadres is beschikbaar na het opslaan van de auto.",
        proFeatureAdminTitle: "Pro kenmerk: Auto beheerders",
        proFeatureAdminDesc: "Voeg andere gebruikers toe die deze autogegevens kunnen bekijken en beheren.",
        proFeatureEmailTitle: "Pro kenmerk: Extra afzenders",
        proFeatureEmailDesc: "Voeg andere toegestane e-mailadressen toe van waaruit ontvangstbewijzen naar deze auto kunnen worden verzonden.",
        estimatedMileage: "Geschatte kilometerstand",
        summaryFrequencyLabel: "Samenvattingsfrequentie",
        summaryFrequencyOptions: {
            none: "Uit",
            monthly: "Maandelijks",
            semiAnnually: "Halfjaarlijks",
            annually: "Jaarlijks",
        },
        healthProfilePrompt: "Voltooi je gezondheidsprofiel voor een nauwkeurige analyse!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzine",
        diesel: "Diesel",
        hybrid: "Hybride",
        electric: "Elektrisch",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Kilometertrend",
        title: "Statistieken",
        allYears: "Alle jaren",
        totalSpent: "Totaal uitgegeven",
        spentIn: "Uitgegeven in {year}",
        perMonth: "per maand",
        overall: "totaal",
        vsPrev12m: "vs vorig. 12m",
        rolling12m: "Laatste 12m",
        byType: "Per type",
        byMonth: "Per maand",
        byYear: "Per jaar",
        noData: "Geen gegevens voor dit jaar",
        mostExpensive: "Duurste",
        top: "Top",
        untitled: "Zonder titel",
        assetAnalysis: "Analyse van activa waarde & kosten",
        burnNote: "* De 'Totaal verbruik' omvat zowel uitgegeven geld als de geschatte afname van de waarde van de auto.",
        carMarketValue: "Marktwaarde auto",
        cumulativeCosts: "Cumulatieve kosten",
        totalBurn: "Totaal verbruik (Kosten + Afschrijving)",
        entries: "invoeren",
        avgPrice: "Gemiddelde prijs",
        consumption: "Verbruik",
        price: "Prijs",
        fuelPriceTrend: "Brandstofprijs trend",
        spendingTrend: "Uitgaven Trend",
        costPerKmTrend: "Kosten per 1 km",
        costPerMileTrend: "Kosten per 1 mijl",
        serviceTrendsTitle: "Service Trends",
        expensesOnMap: "Uitgaven op kaart",
        visitsCountLabel: "bezoeken",
        locationsSummary: "Locaties samenvatting",
        locationsCountLabel: "plaatsen",
        noLocationsFoundTitle: "Nog geen locaties",
        noLocationsFoundDesc: "Voeg locaties toe aan je gegevens om ze op de kaart te zien.",
        addMileageData: "Voeg kilometerstand toe",
        missingMileageInfo: "Niet genoeg gegevens om kosten per afstand te berekenen. Voeg minimaal 2 kilometerstanden toe in deze periode (of één voor deze periode).",
        mileageModal: {
            title: "Voeg Ontbrekende Kilometerstand Toe",
            description: "Om kosten per afstand voor {year} nauwkeurig te berekenen, moeten we de kilometerstand aan het begin en het einde van het jaar weten.",
            startOfYear: "Begin van het jaar (1 jan)",
            endOfYear: "Einde van het jaar (31 dec)",
            currentMileage: "Huidige kilometerstand",
            placeholder: "Voer kilometerstand in...",
            save: "Gegevens Opslaan",
            foundNearby: "Vond in de buurt ({date}): {value} {unit}",
            useExisting: "Gebruik dit",
        },
        proAnalysis: "Pro Analyse",
        detailedAnalysis: "Gedetailleerde Analyse",
        upgradeToSee: "Upgrade om te zien →",
    },
    tabs: {
        dashboard: "Dashboard",
        expenses: "Uitgaven",
        stats: "Statistieken",
        locations: "Locaties",
        gallery: "Bestanden",
        parts: "Onderdelen",
        notes: "Notities",
        repair: "Reparatiemodus",
        'repair-switch': "Auto Wissel",
    },
    repairAnalysis: {
        title: "Analyse van reparatiebeslissingen",
        ownershipLength: "Eigendom Duur",
        currentValue: "Huidige waarde",
        valueOutdated: "Waarde kan verouderd zijn",
        addValueToEnable: "Voeg huidige autowaarde toe om analyse mogelijk te maken",
        totalInvested: "Totaal geïnvesteerd",
        totalInvestedSub: "Aankoopprijs + reparaties",
        totalExcludesFuel: "exclusief brandstof / elektriciteit",
        fuelLabelFuelOnly: "Brandstof totaal",
        fuelLabelEnergyOnly: "Energie totaal",
        fuelLabelHybrid: "Brandstof & Energie totaal",
        fuelTypeFuel: "brandstof",
        fuelTypeEnergy: "elektriciteit",
        fuelTypeHybrid: "brandstof & elektriciteit",
        fuelTotalLabel: "Totaal brandstof/energie:",
        projectionMode: "Projectiemodus",
        projectionModes: {
            lastYear: "Gebaseerd op vorig jaar",
            average: "Historisch gemiddelde",
            trend: "Trend (lineair)",
        },
        brakeAssumption: "Onderhoud omvat geschatte 3-jarige remcyclus",
        repairBuffer: "Inclusief leeftijdsgebonden reparatierisico buffer",
        yearLabel: "jaar",
        totalInvestedDesc: "Aankoopprijs + alle reparaties",
        repairToValue: "Repareren tot waarde (12m)",
        repairToValueExplain: "Reparaties €{cost} versus autowaarde €{value}. Onder 20% is gezond; boven 50% is hoog risico.",
        ownershipPressure: "Eigendom druk",
        ownershipPressureExplain: "Totale kosten druk: reparaties €{cost} + waardeverlies versus €{value}. Boven 35% geeft financiële stress aan.",
        investmentGap: "Investeringskloof",
        investmentGapExplain: "Totaal geïnvesteerd €{invested} min huidige waarde €{value}. Dit toont aan hoeveel je tot nu toe 'verloren' hebt op eigendom.",
        investmentGapDesc: "Totaal geïnvesteerd - huidige waarde",
        repairExpenses12m: "12m Reparatiekosten",
        calculatedYearlyMileage: "Berekende jaarlijkse kilometerstand: {km} km",
        calculatedYearlyRepairs: "Berekende jaarlijkse reparaties: {amount}",
        set: "Instellen",
        plannedRepairCost: "Geplande reparatiekosten",
        whatIfTitle: "Wat als je nu {amount} uitgeeft?",
        updatedScore: "Bijgewerkte score",
        updatedVerdict: "Bijgewerkt oordeel",
        howIsItCalculated: "Hoe wordt dit berekend?",
        usedLifespan: "Gebruikt: {usage}% van verwachte levensduur",
        remainingLifespan: "Overblijvend: ~{km} km",
        estimatedLifespan: "Geschatte levensduur: {km} km",
        lifecycle_stage_early: "Vroeg in de levenscyclus – laag risico op grote storingen",
        lifecycle_stage_mid: "Midden in de levenscyclus – normale slijtage",
        lifecycle_stage_late: "Laat in de levenscyclus – verhoogd risico op reparaties",
        lifecycle_stage_end: "Einde van de verwachte levensduur – hoog risico op grote reparaties",
        calculationExplanation: "De analyse gebruikt de aankoopprijs van je voertuig, recente reparatiekosten en geschatte huidige waarde om een financiële gezondheidsscore te berekenen. Hoge reparatiekosten in verhouding tot de waarde van de auto of snelle afschrijving verlagen de score.",
        confidenceLabel: "Vertrouwen",
        confidenceLevel: {
            high: "Hoog",
            medium: "Gemiddeld",
            low: "Laag",
        },
        mentalFactorsTitle: "Verbeter de nauwkeurigheid met jouw ervaring",
        mentalFactorsCTA: "Snelle controle (30 sec)",
        mentalFactorsSurveyTitle: "Jouw ervaring",
        mentalFactorsSurveyDesc: "Beantwoord 3 snelle vragen om je score te personaliseren.",
        q1: "Voldoet uw auto aan uw behoeften?",
        q1Help: "Ruimte, comfort, functies",
        q2: "Geniet u van het rijden in uw auto?",
        q2Help: "Visueel, comfort, gevoel",
        q3: "Maakt u zich zorgen over onverwachte pech?",
        q3Help: "Betrouwbaarheidszorgen",
        q4: "Is deze auto voor familie- en lange ritten?",
        q4Help: "Veiligheid en betrouwbaarheid prioriteit",
        factorsTitle: "Scorefactoren",
        factorsDesc: "Bekijk wat uw score beïnvloedt",
        newCarComparison: "Vergelijking Nieuwe Auto",
        newCarComparisonDesc: "Vergelijk uw huidige maandlasten met het kopen van een nieuwe auto.",
        modeLeasing: "Leasing",
        modeFullPrice: "Volledige Prijs",
        downPayment: "Aanbetaling",
        leaseYears: "Looptijd (Jaren)",
        monthlyPayment: "Maandlasten",
        carPrice: "Volledige Prijs Auto",
        ownershipYears: "Geplande Eigendom (Jaren)",
        insuranceMonthly: "Maandelijkse CASCO / Verzekering",
        currentMonthlyCost: "Huidige Autokosten",
        newCarMonthlyCost: "Kosten Nieuwe Auto",
        newCarCheaper: "Nieuwe auto is goedkoper met: {amount} / maand",
        newCarMoreExpensive: "Nieuwe auto is duurder met: {amount} / maand",
        newCarSameCost: "Kosten zijn precies hetzelfde.",
        advancedSettings: "Geavanceerde Instellingen",
        yearlyMaint: "Jaarlijks Onderhoud (€)",
        tyres3Yrs: "Banden / 3 jaar (€)",
        depreciation5Yrs: "Afschrijving (5 jaar %)",
        newCarYear: "Jaar Nieuwe Auto",
        cumulativeCosts: "Cumulatieve Kosten (Projectie)",
        comparisonByYear: "Vergelijking per Jaar",
        currentCarLabel: "Huidige Auto",
        newCarLabel: "Nieuwe Auto",
        resaleValue: "Doorverkoopwaarde",
        startupCosts: "Opstartkosten (Tweedehands Auto)",
        inspection: "Voorafgaande inspectie",
        initialMaintenance: "Initiële onderhoud + oliën",
        registration: "Registratie / Kosten",
        total: "Totaal",
        currentCarTitle: "Huidige Auto",
        newCarTitle: "Potentiële Auto",
        upfrontInvestment: "Voorafgaande Investering",
        monthlyReality: "Werkelijke Maandlasten",
        depreciationShort: "Afschrijving",
        howCalculated: "Hoe wordt dit berekend?",
        deltaMonthly: "Maandelijkse verschil",
        deltaUpfront: "Voorafgaand verschil",
        surveyMeanings: {
            practical: {
                1: "Helemaal niet",
                2: "Slechte pasvorm",
                3: "Gemiddeld",
                4: "Goede pasvorm",
                5: "Perfecte pasvorm",
            },
            joy: {
                1: "Frustrerend",
                2: "Saai",
                3: "Gemiddeld",
                4: "Aangenaam",
                5: "Zeer veel",
            },
            worry: {
                1: "Niet bezorgd",
                2: "Enigszins bezorgd",
                3: "Bezorgd",
                4: "Zeer bezorgd",
                5: "Zeker dat ik elk moment kan pech hebben",
            },
        },
        verdicts: {
            KEEP: "Financieel redelijk om te behouden",
            borderline: "Grensgeval – nauwlettend volgen",
            sell: "Hoge financiële risico – verkopen kan rationeel zijn",
        },
        factors: {
            trendInc: "Stijgende Trend",
            trendIncDesc: "Herstelkosten stijgen in vergelijking met vorig jaar.",
            lowDepreciation: "Voordeel van Lage Afschrijving",
            lowDepreciationDesc: "Oudere/goedkopere auto's verliezen minder waarde in de loop van de tijd.",
            stableRepairs: "Stabiele Herstellingen",
            stableRepairsDesc: "Uw herstelkosten zijn stabiel of dalend.",
            noHistoricalData: "Geen gegevens ouder dan 6 maanden.",
            lifecycle_stage: "Fase van de levenscyclus van het voertuig",
            high_risk_phase: "Hoge-risico fase",
            high_risk_phase_desc: "De combinatie van een late levenscyclusfase en stijgende herstelkosten duidt op een hoog risico.",
            lowCostKm: "Efficiënte Kosten per KM",
            lowCostKmDesc: "De algehele efficiëntie van het rijden met deze auto is uitstekend.",
            lowFixedCosts: "Lage Vaste Kosten",
            lowFixedCostsDesc: "Uw vaste kosten (belastingen, verzekering) zijn laag.",
            usage: "Jaarlijks Gebruik",
            usageDesc: "Afstand gereden in de afgelopen 12 maanden.",
            accidentMinor: "Klein Ongeval",
            accidentMinorDesc: "Cosmetische schade of kleine herstellingen.",
            structuralDamage: "Structurele Schade",
            structuralDamageDesc: "Frame- of structurele problemen verlagen de waarde drastisch.",
            aiLifespanNearEnd: "Einde van Verwachte Levensduur",
            aiLifespanAging: "Verouderende Componenten",
            aiLifespanGood: "Voordeel van Lage Kilometerstand",
            aiLifespanDesc: "Gebaseerd op AI geschatte typische levensduur voor dit model.",
            aiUpcomingRepairs: "Aankomende Herstellingen (AI Voorspelling)",
            aiUpcomingRepairsDesc: "AI voorspelt binnenkort grote componentstoringen op basis van kilometerstand.",
            ownershipFatigue: "Eigendom Vermoeidheid",
            ownershipFatigueLong: "Langdurig bezit leidt vaak tot mentale bereidheid voor een ander voertuig.",
            ownershipFatigueShort: "Initiële eigendomsbias creëert een sterkere neiging om de auto te behouden.",
            family_priority: "Familie & Lange Ritten",
            replacement_comparison: "Vervangingsvergelijking",
            none: "Geen",
            surface: "Oppervlak",
            minor: "Klein",
            moderate: "Gemiddeld",
            severe: "Ernstig",
            structural: "Structureel",
            major: "Groot",
            critical: "Kritiek",
            full: "Volledig",
            improveLabel: "Wat zou dit verbeteren:",
            info_original_price: "De geschatte prijs van deze auto toen hij nieuw was. Helpt bij het schatten van waarde stabiliteit. Oudere auto's met een lagere resterende waarde zijn financieel veiliger.",
            info_current_value: "Hoeveel je het vandaag zou kunnen verkopen. Gebruikt om te controleren of reparaties een groot percentage van de autowaarde zijn, wat een slechte investering signaleert.",
            info_yearly_mileage: "Hogere kilometerstand verhoogt slijtage. Lage kilometerstand kan de levensduur van de auto aanzienlijk verlengen.",
            info_estimated_repairs: "Doorlopende kosten om de auto draaiende te houden. Hoge jaarlijkse kosten verminderen de aantrekkelijkheid om de auto te behouden.",
            info_planned_repairs: "Bekende aankomende reparaties. Simuleert onmiddellijke druk op je beslissing.",
            info_ownership_years: "Hoe lang heb je deze auto al? Dit beïnvloedt de psychologische eigendomsmoeheid en de bias van de eerste koper.",
            info_rust: "Kritiek op lange termijn risico. Structurele roest vermindert de veiligheid. Ernstige roest maakt verkopen een betere optie.",
            info_crashes: "Structurele ongevallen beïnvloeden de veiligheid en betrouwbaarheid. Ze verminderen ook de doorverkoopwaarde aanzienlijk.",
            info_repaint: "Geeft aan dat er in het verleden schade of cosmetische reparaties zijn geweest. Kleine impact tenzij diepere problemen verborgen waren.",
            info_unresolved: "Verborgen toekomstige kosten. Bekende fouten in elektronica, motor of onderhoud die aandacht nodig hebben.",
            info_fit: "Past de auto bij je behoeften (ruimte, comfort)? Een slechte pasvorm betekent dat je waarschijnlijker bent om het te vervangen.",
            info_joy: "Emotionele waarde is belangrijk. Geen vreugde betekent dat je mentaal klaar bent voor een nieuwe auto.",
            info_worry: "Perceived reliability stress. Hoge bezorgdheid is een sterk signaal om de auto te vervangen.",
        },
        explanations: {
            repairFreq: "Uw auto had {visits} servicebezoeken in de afgelopen 12 maanden. Frequent bezoek wijst op lagere betrouwbaarheid en meer gedoe.",
            repairVsValue: "In de afgelopen 12 maanden kostten uw herstellingen €{cost}, terwijl de geschatte waarde van de auto €{value} is. Dat is {ratio}% van de totale waarde van de auto.",
            stableRepairsDetailYearly: "Vorig jaar heb je €{cost1} aan reparaties uitgegeven, maar het jaar daarvoor €{cost2}. Verandering van {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "Afgelopen 6 maanden heb je €{cost1} uitgegeven, de 6 maanden daarvoor €{cost2}. Verandering van {percent}% ({trend}).",
            mileage: "Bij {mileage} km komt de auto in een hogere risicogroep voor grote onderdelenstoringen (transmissie, motorcomponenten).",
            planned: "U heeft €{cost} aan geplande herstellingen, wat de financiële veiligheid van het behouden van de auto onmiddellijk vermindert.",
            lowDep: "Auto's met een waarde van rond €{value} verliezen zeer weinig waarde per jaar, wat hogere herstelkosten compenseert.",
            depRisk: "Uw auto is {age} jaar oud en heeft zijn afschrijvingscyclus grotendeels voltooid, wat betekent dat u geen geld verliest door de waardedaling.",
            stable: "U gaf €{costThisYear} dit jaar uit versus €{costLastYear} vorig jaar, wat een daling van {percent}% is. Voorspelbare kosten zijn wiskundig gunstig.",
            costKm: "U reed {km} km vorig jaar. De bedrijfskosten waren €{costKm} per kilometer, wat uitstekende economische efficiëntie aantoont.",
            fixedCosts: "U betaalde €{costs} aan vaste jaarlijkse kosten (verzekering/belasting). Deze lage voetafdruk geeft extra gemoedsrust.",
            usage: "U rijdt ongeveer {km} km per jaar op basis van uw logboeken.",
            practical_fit: "U beoordeelde de praktische geschiktheid op {score}/5, wat de wiskundige score met {impact} punten aanpaste.",
            emotional_satisfaction: "U beoordeelde uw emotionele tevredenheid op {score}/5, wat de score met {impact} punten aanpaste.",
            reliability_anxiety: "Uw vertrouwen in de betrouwbaarheid is {score}/5, wat de score met {impact} punten beïnvloedt.",
            rust: "Ernstige structurele of onderliggende roest betekent doorgaans veiligheidsrisico's of afschrijvingsscenario's.",
            accident: "Eerdere schade, afhankelijk van de ernst, vermindert inherent de wederverkoopwaarde en veiligheid van het voertuig.",
            structural: "Structurele problemen maken de auto automatisch financieel gevaarlijk.",
            ai_lifespan: "Bij {current} km heeft de auto {ratio}% van zijn door AI geschatte levensduur ({expect} km) voltooid.",
            ai_repairs: "De AI-gegevens geven aan dat er bij deze kilometerstand {count} typische model-specifieke grote reparaties plaatsvinden.",
            lifecycle_stage: "Wat betekent levensduur? {total} km – dit is het door AI voorspelde punt waarop grote structurele reparaties (motor, versnellingsbak, enz.) typisch beginnen voor dit model. Het is niet het einde van het leven van de auto – de auto kan nog steeds rijden, maar met aanzienlijk hogere onderhoudskosten. De volledige fysieke levensduur van een typische auto is 500k–1M km, maar het wordt veel eerder economisch onhaalbaar.",
        },
        ratios: {
            healthy: "Gezond",
            monitor: "Monitoren",
            highRisk: "Hoge risico",
            stable: "Stabiel",
            warning: "Waarschuwing",
            financialStress: "Financiële stress",
        },
        proFeatureTitle: "Pro-functie: Reparatiemodus",
        proFeatureDesc: "Ontgrendel de beslissingsengine om een professionele financiële analyse van uw voertuigreparaties te krijgen. Gratis gebruikers zien een demonstratie met voorbeeldgegevens.",
        viewDemo: "Bekijk Live Demo",
        upgradeToUnlock: "Upgrade naar PRO om uw auto te analyseren",
    },
    carTasks: {
        title: "Auto Taken",
        placeholderTitle: "Onderhoudsregistratie",
        placeholderDesc: "Onderhoudsschema voor uw automodel.",
        demoTitle: "Auto Onderhoudstaken",
        demoSubtitle: "Slimme registratie voor uw voertuig",
        feature1Title: "Geautomatiseerde Taakgeneratie",
        feature1Desc: "Genereert automatisch taken zoals olie verversen, filter vervangen en distributieriemcontroles op basis van het model van uw auto.",
        feature2Title: "Kostenintegratie",
        feature2Desc: "Analyseert uw servicegeschiedenis om te begrijpen wat er al is gedaan en wanneer.",
        feature3Title: "Slimme Herinneringen",
        feature3Desc: "Ontvang meldingen op basis van zowel tijd als kilometerstand. De registratie reset automatisch wanneer u een taak als voltooid markeert.",
        getStarted: "Aan de Slag",
        fakeDoorPopupTitle: "Feedback Welkom",
        fakeDoorPopupMessage: "We zijn momenteel bezig met het ontwikkelen van autoonderhoudstaken. Deze functie stelt u in staat om service-intervallen automatisch bij te houden. Welke specifieke taken of functies zou u het liefst willen zien?",
        fakeDoorPopupPlaceholder: "Uw gedachten...",
        noTasksYet: "Nog geen taken",
        deleteAllTitle: "Taaklijst wissen?",
        deleteAllMessage: "Weet u zeker dat u alle {count} taken voor deze auto wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        deleteAllSuccess: "Alle taken zijn succesvol verwijderd.",
        sortPriority: "Prioriteit",
        sortType: "Type",
        sortDate: "Laatste",
        status: {
            overdue: "TE LAAT",
            pending: "In afwachting",
            noData: "GEEN GEGEVENS",
            upcoming: "Aanstaande",
            nextIn: "Volgende in {dist} {unit}",
            overdueBy: "{dist} {unit} te laat",
            afterDays: "Over {days} dagen",
            overdueDays: "{days} dagen te laat",
        },
        form: {
            newTitle: "Nieuwe Taak",
            actionType: "Inspecteren of Vervangen?",
            intervalMonths: "Interval (Maanden)",
            intervalDistance: "Interval (Afstand)",
            diffFirstInterval: "Eerste interval verschilt van basisinterval",
            firstInterval: "Eerste Interval",
            historyToggle: "Is deze taak ooit uitgevoerd voor deze auto?",
            historyToggleDesc: "Als NEE, gaan we ervan uit dat het nooit is gedaan sinds de productie.",
            lastPerformedOptional: "Wanneer is het voor het laatst uitgevoerd? (Optioneel)",
            deleteTitle: "Taak Verwijderen",
            deleteConfirm: "Weet u zeker dat u deze taak wilt verwijderen?",
            saveError: "Opslaan van taak mislukt",
            historyConfirmed: "Geschiedenis Bevestigd",
            reminders: "Herinneringen",
            notifyMileage: "Laat het me weten wanneer de geschatte kilometerstand is bereikt",
            notifyDate: "Laat het me weten wanneer de datum is bereikt",
            nextMileageReminder: "Geschatte datum",
            nextDateReminder: "Vervaldatum",
            estimatedDate: "Geschatte datum",
            missingLastMileage: "Laatste gereden kilometerstand ontbreekt",
            missingLastDate: "Laatste uitgevoerde datum ontbreekt",
            missingStartDate: "Startdatum kon niet worden bepaald",
            additionalOptions: "Aanvullende opties",
            reminderInfoMissing: "Informatieve status: herinneringen zijn uitgeschakeld totdat de laatste uitgevoerde gegevens zijn verstrekt.",
        },
    },
    dashboard: {
        title: "Dashboard",
        quickActions: "Snelle Acties",
        addExpense: "Uitgave Toevoegen",
        editCar: "Auto Bewerken",
        recentExpenses: "Uitgaven",
        seeAll: "Bekijk Alles",
        recentGallery: "Bestanden",
        thisMonth: "Deze Maand",
        totalSpent: "Totaal Besteed",
        avgPerMonth: "Gem. per Maand",
        recentNotes: "Notities",
        recentParts: "Onderdelen",
        noRecentExpenses: "Geen recente uitgaven",
        noRecentGallery: "Geen recente foto's",
        noRecentNotes: "Geen recente notities",
        noRecentParts: "Geen recente onderdelen",
        createNote: "Nieuwe Aanmaken",
        createPart: "Nieuwe Aanmaken",
        createExpense: "Nieuwe Aanmaken",
        noFiles: "Nog geen bestanden toegevoegd",
        needSomethingMore: "Heb je iets meer nodig?",
        letUsKnow: "Laat het ons weten!",
    },
    expenseTypes: {
        editTitle: "Uitgave Type Bewerken",
        newTitle: "Nieuw Uitgave Type",
        categoryName: "Categorie Naam",
        placeholderName: "bijv. Service",
        signatureColor: "Handtekening Kleur",
        icon: "Categorie Icoon",
        deleteConfirm: "Weet u zeker dat u het type '{name}' wilt verwijderen?",
    },
    spareParts: {
        title: "Reserve Onderdelen",
        connectedWithRecords: "Verbonden met Records",
        toBuy: "Te Kopen",
        usedInExpenses: "Gebruikt in Uitgaven",
        noPartsToBuy: "Geen onderdelen toegevoegd aan de boodschappenlijst",
        noPartsUsed: "Geen onderdelen gekoppeld aan uitgaven",
        quantity: "Aantal",
        partCode: "Onderdelen Code",
        price: "Prijs",
        link: "Link",
        comment: "Opmerking",
        addPart: "Reserve Onderdeel Toevoegen",
        editPart: "Reserve Onderdeel Bewerken",
        openPart: "Open Onderdeleninvoer",
        nameLabel: "Naam",
        manufacturerLabel: "Fabrikant",
        priceLabel: "Prijs ({currency})",
        imagesLabel: "Bestanden",
        linkedHistory: "Gekoppelde Geschiedenis",
        partManagedNote: "Dit onderdeel wordt beheerd via een uitgave",
        cannotDeleteNote: "Aangezien dit onderdeel is gekoppeld aan een uitgave, kan het niet afzonderlijk worden verwijderd. Verwijder of bewerk de uitgave om de levenscyclus van dit onderdeel te beheren.",
        partNamePlaceholder: "Onderdeel naam...",
        manufacturerPlaceholder: "Bosch, Brembo, enz.",
        additionalInfoPlaceholder: "Aanvullende informatie...",
        namePlaceholder: "bijv. Remblokken",
        codePlaceholder: "bijv. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Onderdeel Opslaan",
        deletePart: "Verwijder reserve onderdeel",
        deleteConfirm: "Weet u zeker dat u dit reserve onderdeel wilt verwijderen?",
        sparePartsLabel: "Reserve Onderdelen",
        partNumber: "Onderdeel #{number}",
        imagesLimitLabel: "Bestanden (tot 5)",
        optional: "(optioneel)",
        selectPart: "Selecteer Reserve Onderdeel",
        createNew: "Maak nieuw reserve onderdeel",
        searchPlaceholder: "Zoek op naam of code...",
        noResults: "Geen onderdelen gevonden",
        noPartsYet: "Nog geen onderdelen. Maak uw eerste!",
        selectorDescription: "Vind en selecteer een bestaand reserve onderdeel, of maak een nieuwe aan",
        alreadyAdded: "Dit onderdeel is al toegevoegd",
        statistics: {
            avgPrice: "Gem.",
            lastPrice: "Laatste",
            usedTimes: "Gebruikt {count} keer",
            totalPurchased: "Totaal: {quantity}x",
        },
        usage: {
            title: "Deze Aankoop",
            quantity: "Aantal",
            pricePerUnit: "Prijs per eenheid",
            comment: "Opmerking",
            commentPlaceholder: "bijv., Gekocht bij AutoZone",
            total: "Totaal",
            transactionData: "Deze Transactie",
        },
        masterData: "Hoofdonderdeel Info",
        masterRecord: {
            title: "Onderdeel Gegevens (gedeeld)",
            editMaster: "Bewerk Hoofdrecord",
            warning: "Wijzigingen in het hoofdrecord beïnvloeden alle gebruiksgegevens",
        },
    },
    reminders: {
        title: "Herinneringen",
        reminder: "Herinnering",
        noteReminder: "Notitie Herinnering",
        partReminder: "Onderdeel Herinnering",
        today: "Vandaag",
        tomorrow: "Morgen",
        yesterday: "Gisteren",
        inXDays: "over {x} dagen",
        xDaysAgo: "{x} dagen geleden",
        inXMonths: "over {x} maanden",
        xMonthsAgo: "{x} maanden geleden",
        active: "Actief",
        activeDesc: "Indien nodig kunt u deze herinnering uitschakelen zonder deze te verwijderen",
        disabled: "Uitgeschakeld",
        yearly: "Jaarlijks",
        markSeen: "Bevestigen",
        addReminder: "Nieuwe Herinnering",
        editReminder: "Herinnering Bewerken",
        extraReminders: "Extra Herinneringen",
        extraRemindersDesc: "Stuur 3 extra herinneringen op de volgende dagen (4 in totaal) als niet gestopt.",
        remindDate: "Datum",
        remindTime: "Tijd",
        repeatYearly: "Herhaal Jaarlijks",
        repeatYearlyDesc: "Deze herinnering zal automatisch elk jaar op dezelfde datum/maand/dag/tijd plaatsvinden totdat deze is uitgeschakeld",
        standalone: "Standalone Herinneringen",
        embedded: "Gekoppelde Herinneringen",
        noReminders: "Geen actieve herinneringen",
        deleteReminder: "Verwijder Herinnering",
        nameLabel: "Naam",
        descriptionLabel: "Beschrijving",
        namePlaceholder: "Naam van de herinnering",
        descriptionPlaceholder: "Korte beschrijving of notitie",
        simulateReminder: "Simuleer herinneringsmoment",
        simulateSuccess: "Simulatie-e-mail verzonden",
        timezone: "Tijdzone",
        nextReminder: "Volgende herinnering",
        futureTimeError: "Herinneringstijd moet in de toekomst liggen",
    },
    notes: {
        title: "Notities",
        emptyNote: "Lege notitie",
        noNotes: "Nog geen notities",
        addNote: "Voeg Notitie Toe",
        editNote: "Bewerk Notitie",
        viewNote: "Bekijk Notitie",
        openNote: "Open Notitie-invoer",
        titleLabel: "Titel",
        contentLabel: "Inhoud",
        noteTitlePlaceholder: "Titel van de notitie...",
        noteContentPlaceholder: "Schrijf hier je notitie...",
        saveNote: "Notitie opslaan",
        deleteNote: "Notitie verwijderen",
        publicNote: "Maak notitie openbaar",
        publicNoteDesc: "Anderen kunnen deze notitie bekijken via de gedeelde link",
        deleteConfirm: "Weet je zeker dat je deze notitie wilt verwijderen?",
        enterTitleAlert: "Voer een titel in",
        saveFailed: "Opslaan van notitie is mislukt",
        thisNote: "Deze notitie",
        deleteFailed: "Verwijderen van notitie is mislukt",
        pinToTop: "Bovenaan vastzetten",
    },
    locations: {
        title: "Locaties",
        singleTitle: "Locatie",
        newLocation: "Nieuwe Locatie",
        emptyLocation: "Lege locatie",
        noLocations: "Voor statistieken - je kunt de locatie toevoegen waar deze autokosten zijn gemaakt",
        addLocation: "Locatie toevoegen",
        editLocation: "Locatie bewerken",
        viewLocation: "Locatie bekijken",
        openLocation: "Locatie openen",
        createNew: "Nieuwe locatie aanmaken",
        selectLocation: "Selecteer locatie",
        searchLocations: "Zoek locaties...",
        nameLabel: "Naam",
        addressLabel: "Adres of Coördinaten",
        descriptionLabel: "Opmerking/Beschrijving",
        namePlaceholder: "bijv. Downtown Service",
        mapLabel: "Locatie",
        searchPlaceholder: "Zoek adres...",
        addressPlaceholder: "Voer adres in en selecteer...",
        descriptionPlaceholder: "Extra info...",
        fillAddress: "Vul adres in vanaf de kaart",
        saveLocation: "Locatie opslaan",
        deleteLocation: "Locatie verwijderen",
        deleteConfirm: "Weet je zeker dat je deze locatie wilt verwijderen?",
        enterNameAlert: "Voer een naam in",
        saveFailed: "Opslaan van locatie is mislukt",
        thisLocation: "Deze locatie",
        deleteFailed: "Verwijderen van locatie is mislukt",
        myLocations: "Mijn Locaties",
        usedInEntries: "Gebruikt in invoeren",
        noEntries: "Locatie wordt niet gebruikt",
        noEntriesThisCar: "Deze locatie is niet gebruikt voor deze auto",
        removeLocation: "Locatie verwijderen",
        noResults: "Geen resultaten gevonden",
    },
    gallery: {
        title: "Bestanden",
        noImages: "Geen afbeeldingen toegevoegd",
        addImagesNote: "Voeg afbeeldingen toe aan auto of kosten",
        totalImages: "Totaal {count} afbeeldingen",
        imageAlt: "Afbeelding {number}",
        commentPlaceholder: "Bestandsopmerking",
        isReceipt: "Dit bestand is een bon",
        deleteImageTitle: "Verwijder bestand",
        deleteImageConfirm: "Weet je zeker dat je dit bestand permanent wilt verwijderen?",
    },
    search: {
        placeholder: "Zoek kosten, onderdelen, notities...",
        typeToSearch: "Typ om te beginnen met zoeken",
        noResults: "Geen resultaten gevonden voor '{query}'",
        carImage: "Auto-afbeelding",
        expenseImage: "Kostenafbeelding",
        noteImage: "Notitie-afbeelding",
        galleryImage: "Galerijafbeelding",
        untitledExpense: "Ongetitelde kosten",
    },
    landing: {
        nav: {
            features: "Functies",
            howItWorks: "Hoe het werkt",
            pricing: "Prijzen",
            login: "Inloggen",
            getStarted: "Beginnen",
            garage: "Garage",
        },
        hero: {
            title: "Weet Exact Wat Uw Auto",
            subtitle: "Echt Kost",
            description: "Houd uitgaven bij, log reparaties en zie waar uw geld echt naartoe gaat.",
            subheadline: "Het professionele datagestuurde dashboard voor nauwkeurige autobezitters.",
            startTracking: "Beginnen",
            viewDemo: "Demo Auto ->",
            trustSignal: "Sluit je aan bij 1.200+ nauwkeurige eigenaren die al meer dan 5 miljoen kilometer aan werkelijke autokosten hebben in kaart gebracht.",
            ctaNote: "Geen creditcard. Geen opdringerige verkoop. Gewoon duidelijkheid.",
            benefits: {
                repairVsSell: {
                    title: `Repareren vs. Verkopen`,
                    description: `Spot de "Repareren vs. Verkopen" drempel — Stop met je af te vragen of je geld in een geldput stopt. Weet het exacte moment waarop een reparatie geen slimme investering meer is.`
                },
                costPerKm: {
                    title: `Kosten-per-KM`,
                    description: `Volg je werkelijke kosten-per-kilometer — Ga verder dan het dashboard. Zie het volledige financiële plaatje van je rijgedrag dat andere apps achterlaten.`
                },
                automation: {
                    title: `Automatisering`,
                    description: `Automatiseer je administratie — Stuur gewoon je facturen door of e-mail je notities. Onze AI organiseert de technische geschiedenis van je auto voor je.`
                }
            },
        },
        features: {
            title: "Alles wat je nodig hebt om je auto te beheren",
            subtitle: "Stop met het gebruik van spreadsheets en rommelige mappen. My Car Costs brengt professionele vlootbeheer tools naar jouw persoonlijke garage.",
            expenseTracking: {
                title: "Kosten Bijhouden",
                description: "Log brandstof, service, verzekering en reparaties. Categoriseer kosten en visualiseer uitgaven trends in de tijd.",
            },
            spareParts: {
                title: "Onderdelenbeheer",
                description: "Houd een gedetailleerde inventaris bij van onderdelen, onderdeelnummers en compatibiliteitsnotities voor al jouw reparaties.",
            },
            serviceHistory: {
                title: "Servicegeschiedenis & Notities",
                description: "Onderhoud een digitaal serviceboek. Voeg gedetailleerde notities toe over onderhoud, aanpassingen of toekomstige plannen.",
            },
            documentStorage: {
                title: "Documentopslag",
                description: "Upload bonnetjes, facturen en foto's van jouw auto. Houd al jouw documentatie veilig en toegankelijk.",
            },
            emailForwarding: {
                title: "E-mail Doorsturen",
                description: "Stuur facturen rechtstreeks naar jouw unieke inbox. Wij extraheren de gegevens en voegen deze automatisch toe aan jouw dashboard.",
            },
            multiCar: {
                title: "Multi-Auto Garage",
                description: "Beheer één auto of een hele vloot. Wissel direct tussen voertuigen en zie geaggregeerde statistieken.",
            },
            repeatingExpenses: {
                title: "Herhalende Uitgaven",
                description: "Automatiseer het bijhouden van reguliere maandelijkse kosten zoals verzekering, parkeren of leasing.",
            },
            smartReminders: {
                title: "Slimme Herinneringen",
                description: "Stel aangepaste waarschuwingen in voor reserveonderdelen en service-notities zodat je nooit een onderhoudstaak mist.",
            },
        },
        howItWorks: {
            title: "Eenvoudige, krachtige workflow",
            step1: {
                title: "Voeg jouw voertuig toe",
                description: "Voer de gegevens van jouw auto in om jouw digitale garage te creëren.",
            },
            step2: {
                title: "Log kosten & bestanden",
                description: "Maak een foto van een bon of stuur een e-mail door. Wij regelen de rest.",
            },
            step3: {
                title: "Krijg inzichten",
                description: "Zie jouw kosten per kilometer, maandelijkse uitgaven en onderhoudstijdlijn.",
            },
        },
        useCases: {
            title: "Perfect voor",
            enthusiasts: {
                title: "Autoliefhebbers",
                description: "Houd elke aanpassing, onderdeelnummer en onderhoudsinterval bij voor jouw projectauto.",
            },
            dailyDrivers: {
                title: "Dagelijkse Bestuurders",
                description: "Weet precies hoeveel jouw woon-werkverkeer kost en mis nooit een service datum.",
            },
            flippers: {
                title: "De Slimme Flipper",
                description: "Bouw een verifieerbaar volume aan gegevens op dat de werkelijke waarde van je auto aan kopers bewijst.",
            },
            fleets: {
                title: "Kleine Vloten",
                description: "Beheer meerdere bedrijfsvoertuigen op één plek zonder de rompslomp van enterprise software.",
            },
        },
        foundersNote: {
            title: "Opmerking van de Oprichter",
            content: "Ik bouw MyCarCosts om de ultieme tool te zijn voor mensen die echt om hun auto geven. Mist er een functie in je workflow? Neem direct contact met me op. Als het zinvol is voor de gemeenschap, bouwen we het samen.",
        },
        pricing: {
            freeLimitedTime: "Tijdelijk gratis",
            title: "Eenvoudige, transparante prijzen",
            subtitle: "Begin gratis, upgrade terwijl je groeit.",
            perMonth: "maand",
            monthly: "Maandelijks",
            yearly: "Jaarlijks",
            save25: "Bespaar 25%",
            billedAnnually: "Jaarlijks gefactureerd ({amount})",
            free: {
                title: "Gratis",
                cta: "Aan de slag",
            },
            pro: {
                title: "Pro",
                cta: "Upgrade naar Pro",
                recommended: "Aanbevolen",
                earlyAdopter: "Vroegbieder prijs",
                priceLock: "Vergrendel deze prijs nu. De prijs kan in de toekomst stijgen.",
            },
            custom: {
                title: "Custom",
                cta: "Neem contact met ons op",
            },
            features: {
                oneCar: "1 auto",
                unlimitedExpenses: "Onbeperkte uitgaven",
                unlimitedSpareParts: "Onbeperkte reserveonderdelen",
                unlimitedNotes: "Onbeperkte notities",
                repeatedExpenses: "Herhaalde uitgaven",
                emailReminders: "Notities en reserveonderdelen e-mailherinneringen",
                basicStatistics: "Basisstatistieken",
                fullStatistics: "Volledige statistieken",
                storage50mb: "50 Mb bestandopslag",
                unlimitedArchivedCars: "Onbeperkte gearchiveerde auto's",
                dataExport: "Gegevens exporteren",
                allInFreePlus: "alles in gratis plus:",
                threeCars: "Tot 3 auto's",
                storage2gb: "2 Gb bestandopslag",
                emailParsing: "E-mail parsing",
                carAdmins: "Auto beheerders",
                moreCars: "Meer auto's",
                moreFileStorage: "Meer bestandopslag",
                customRequirements: "Aangepaste vereisten",
            },
            upgradePopup: {
                title: "Binnenkort Beschikbaar!",
                message: "De pro- en aangepaste versies zijn nog niet gelanceerd, maar dat zal binnenkort gebeuren. Om ons te helpen sneller te lanceren - schrijf alsjeblieft op welke specifieke functie je verwacht van de pro / aangepaste versie, of iets anders dat je graag zou willen dat we verbeteren om dit platform nog beter voor je te maken!",
                placeholder: "Schrijf hier je feedback...",
                submit: "Verzenden",
                cancel: "Annuleren",
                thanksTitle: "Bedankt!",
                thanksMessage: "We hebben je feedback ontvangen en zullen werken om MyCarCosts nog beter te maken!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Overstappen van Excel of een andere app?",
            subtitle: "We bieden een professionele gegevensmigratieservice om je direct op weg te helpen.",
            pricingModel: "Prijsmodel",
            small: {
                title: "Kleine dataset",
                description: "< 500 rijen",
                price: "$19–29",
            },
            medium: {
                title: "Middelgrote dataset",
                description: "500–5.000 rijen",
                price: "$49",
            },
            large: {
                title: "Grote / Rommelige",
                description: "Legacy-systemen of complexe bestanden",
                price: "Aangepaste offerte",
            },
            process: {
                title: "Hoe het werkt",
                step1: "Je dient je bestand in",
                step2: "We evalueren de gegevens",
                step3: "Eenmalige betaling",
                step4: "Wij regelen de import",
            },
            cta: "Vraag migratie aan",
        },
        repairAnalysisSection: {
            title: "Repareren of Verkopen? Laat de gegevens beslissen.",
            subtitle: "Professionele financiële analyse voor jouw voertuig. Stop met raden en begin te weten of die reparaties echt de moeite waard zijn.",
            features: {
                personalized: {
                    title: "Gepersonaliseerde Analyse",
                    description: "Voor je geregistreerde auto's gebruiken we echte historische uitgaven en parameters, waarbij we geplande kosten toevoegen om een beoordeling te genereren.",
                },
                public: {
                    title: "Open Simulator",
                    description: "Evalueer een potentiële aankoop? Gebruik onze openbare tool op /repair om een gedetailleerde analyse te genereren door slechts een paar belangrijke details in te voeren.",
                },
                whatIf: {
                    title: "Wat-Als Simulator",
                    description: "Voer een geplande reparatiekost in en zie onmiddellijk hoe dit je financiële score van de auto beïnvloedt.",
                },
            },
            cta: "Bekijk voorbeeldanalyse",
        },
        faq: {
            title: "Veelgestelde Vragen",
            subtitle: "Alles wat je moet weten over My Car Costs",
            questions: {
                mobileApps: {
                    question: "Zullen er iOS- en Android-apps zijn?",
                    answer: "Ja! Mobiele apps voor zowel iOS als Android komen binnenkort. We werken hard om je de beste mobiele ervaring te bieden.",
                },
                dataPrivacy: {
                    question: "Is mijn data privé en veilig?",
                    answer: "Absoluut. Je gegevens zijn versleuteld en veilig opgeslagen. Alleen jij kunt toegang krijgen tot je auto-informatie, tenzij je expliciet kiest om deze openbaar te maken.",
                },
                freePlan: {
                    question: "Is het gratis plan echt voor altijd gratis?",
                    answer: "Ja! Het gratis plan zal altijd beschikbaar zijn met één auto en alle essentiële functies. Je kunt op elk moment upgraden naar Pro voor tot 3 auto's en geavanceerde functies.",
                },
                dataExport: {
                    question: "Kan ik mijn gegevens exporteren?",
                    answer: "Ja, je kunt al je gegevens op elk moment exporteren in CSV- of PDF-formaat. Jouw gegevens zijn van jou, en je zit nooit vast.",
                },
                emailImport: {
                    question: "Hoe werkt e-mailimport?",
                    answer: "Elke auto krijgt een uniek e-mailadres. Stuur gewoon je facturen door en wij extraheren de gegevens automatisch.",
                },
                multipleUsers: {
                    question: "Kunnen meerdere mensen dezelfde auto benaderen?",
                    answer: "Momenteel behoort elke auto tot één account. Je kunt echter een auto openbaar maken om alleen-lezen toegang met anderen te delen.",
                },
            },
        },
        cta: {
            title: "Stop met gokken. Begin met weten.",
            subtitle: "Verander de historie van uw auto in duidelijke financiële beslissingen. Sluit u aan bij duizenden slimme eigenaren die precies weten wanneer ze moeten investeren of verkopen.",
            button: "Nu beginnen",
            note: "Geen creditcard. Geen opdringerige verkoop. Gewoon duidelijkheid.",
        },
        footer: {
            product: "Product",
            legal: "Juridisch",
            changelog: "Wijzigingslog",
            privacy: "Privacybeleid",
            contact: "Contact",
            contactEmail: "info@mycarcosts.com",
            questions: "Heb je vragen? Neem contact met ons op via:",
        },
        privacy: {
            title: "Privacybeleid",
            lastUpdated: "Laatst bijgewerkt: 25 maart 2026",
            introduction: "Bij My Car Costs nemen we uw privacy serieus. Dit beleid legt uit hoe we met uw gegevens omgaan.",
            dataCollection: {
                title: "Gegevensverzameling",
                description: "We verzamelen alleen de absoluut minimale informatie die nodig is om onze service te bieden.",
                email: "Accountidentiteit: We gebruiken je e-mailadres als je unieke identificatie en voor authenticatie (bijv. magische links of Google-login).",
                documents: "Documentopslag: Bestanden die je uploadt worden veilig opgeslagen in versleutelde cloudopslag.",
            },
            carData: {
                title: "Jouw Gegevenscontrole",
                description: "Informatie die je invoert (uitgaven, kilometerstand, onderdelen) wordt opgeslagen voor jouw persoonlijk gebruik en analyses.",
                noValidation: "We valideren de autogegevens die je verstrekt niet; het is jouw verantwoordelijkheid om de nauwkeurigheid te waarborgen.",
                privateByDefault: "Standaard zijn je gegevens privé. Technische identificatoren voor bestanden zijn niet-sequentieel en worden niet geïndexeerd door zoekmachines.",
                rightToForgotten: "Recht om Vergeten te Worden: Je kunt je account op elk moment verwijderen, wat onmiddellijk en permanent al je records en bestanden verwijdert.",
            },
            thirdParty: {
                title: "Diensten van derden",
                description: "Wij verkopen uw persoonlijke gegevens niet. Bij het gebruik van Google Login hebben we alleen toegang tot uw e-mailadres voor identificatiedoeleinden.",
            },
            emailIngestion: {
                title: "E-mailverwerking",
                description: "E-mails die naar onze verwerkingsservice worden verzonden, worden opgeslagen om een verwerkingsgeschiedenis te bieden. U kunt op elk moment handmatig individuele e-mails of uw volledige geschiedenis verwijderen.",
            },
        },
        emails: {
            deleteAll: "Alles verwijderen",
            deleteAllConfirm: "Weet u zeker dat u de volledige e-mailgeschiedenis voor deze auto wilt verwijderen? Deze actie is onomkeerbaar.",
            deleteConfirm: "Weet u zeker dat u deze e-mail wilt verwijderen?",
            noEmails: "Nog geen e-mails ontvangen.",
        },
        terms: {
            title: "Algemene Voorwaarden",
            lastUpdated: "Laatst bijgewerkt: 25 maart 2026",
            introduction: "Door MyCarCosts te openen of te gebruiken, gaat u ermee akkoord gebonden te zijn aan deze Algemene Voorwaarden. Indien u niet akkoord gaat, verzoeken wij u onze dienst niet te gebruiken.",
            acceptance: {
                title: "1. Acceptatie van Voorwaarden",
                description: "Deze voorwaarden vormen een juridisch bindende overeenkomst tussen u en MyCarCosts met betrekking tot uw gebruik van onze applicatie en diensten.",
            },
            service: {
                title: "2. Beschrijving van de Dienst",
                description: "MyCarCosts biedt een platform voor het bijhouden van voertuiguitgaven, onderhoudsbeheer en financiële analyse. Dit omvat door AI aangestuurde verwerking van kwitantiestukken en hulpmiddelen voor datavisualisatie.",
            },
            responsibilities: {
                title: "3. Verantwoordelijkheden van de Gebruiker",
                description: "U bent verantwoordelijk voor de nauwkeurigheid van alle gegevens die u invoert, inclusief kilometerstand, VIN-nummers en kosten. U moet uw inloggegevens (e-mail/magic link) veilig bewaren en deze niet delen met onbevoegde partijen.",
            },
            plans: {
                title: "4. Dienstplannen en Limieten",
                description: "Wij bieden Gratis en Pro plannen aan met verschillende opslag-, auto-aantal- en uploadlimieten. Wij behouden ons het recht voor om deze limieten te wijzigen of op elk moment nieuwe abonnementen te introduceren.",
            },
            disclaimer: {
                title: "5. Disclaimers en Nauwkeurigheid",
                description: "MyCarCosts is een informatie- en organisatiehulpmiddel. Wij verstrekken geen officiële gezondheidscertificaten voor voertuigen. Door AI verwerkte gegevens van kwitantiestukken moeten altijd door de gebruiker op nauwkeurigheid worden gecontroleerd.",
            },
            liability: {
                title: "6. Beperking van Aansprakelijkheid",
                description: "MyCarCosts wordt geleverd 'as-is'. Wij zijn niet aansprakelijk voor mechanische problemen, financiële verliezen of onnauwkeurigheden in gegevens die voortvloeien uit het gebruik van onze applicatie.",
            },
            termination: {
                title: "7. Beëindiging",
                description: "U kunt het gebruik van de dienst op elk moment stopzetten en uw gegevens verwijderen. Wij behouden ons het recht voor om accounts op te schorten of te beëindigen die deze voorwaarden schenden of zich schuldig maken aan misbruik.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

